import { selectFromUserDto } from '../../models';

//Due to issues with our eager structure, we require the following at a minimum - Please do not remove these:
/*    access_token
     organization {
      id
      uuid
      name
      address
      phoneNumber
      website
    }
  }
*/
export default selectFromUserDto()
  .access_token
  .uuid
  .email
  .fullname
  .organization(org => org
    .uuid
    .name
    .address
    .phoneNumber
    .website)
  .toString();
